<template>
    <div class='page_content'>
        <subComponents ref="showSelectData"></subComponents>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign"></v-button>
            <div class="page_content_top_line">
                <vSearch @searchData="searchData" @openSearchs="openSearch" :getRequestData=getRequestData v-if="pageShowData.jurHead" :searchList=pageShowData.jurHead.jurconfigform>
                </vSearch>
            </div>
        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="汇总" name="first">
                <div class="page_content_center" style="padding-top: 10px;">
                    <el-table @selection-change="handleSelectionChange" size="mini" v-if="pageShowData.jurTableVo" :data="returnData.list" :height="tableHeight - 50" :key="$store.state.tableNum" border
                              style="width: 100%" @row-click="rowClick" :row-class-name="rowClassName" @sort-change="sortChange">
                        <el-table-column align="center" width="50" type="selection"></el-table-column>
                        <el-table-column align="center" v-if="tableValye.isShow == 1" show-overflow-tooltip :min-width="tableValye.fieldWeight" v-for="(tableValye, tableKey) in pageShowData.jurTableVo.jurconfigtable"
                                         :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField" :sortable="tableValye.isSort == 1 ? 'custom' : false">
                            <template slot-scope="scope">
                                <span v-if="tableValye.fieldType == 'date'">
                                    <span v-if="scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                </span>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.entityField]
                                }}</a>
                                </span>
                                <span v-else-if="tableValye.entityField == 'createTime'">
                                    <span v-if="scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                </span>

                                <el-tag v-else-if="tableValye.entityField == 'state'" size="mini" type="primary">
                                    {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                                <span v-else-if="tableValye.fieldType == 'formatter'">
                                    {{ $common.getIsGsp(tableValye.formatterContent,
                                scope.row[tableValye.entityField])
                            }}
                                </span>
                                <span v-else>
                                    {{ scope.row[tableValye.entityField] }}
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="明细" name="second">
                <div class="page_content_center" style="padding-top: 10px;">
                    <el-table v-if="pageShowData.jurFormVoList" class="table1" :data="returnData.list" :height="tableHeight - 50" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini"
                              @row-click="rowClick" :row-class-name="rowClassName" @sort-change="sortChange">
                        <el-table-column align="center" v-if="tableValye.isShow == 1" v-for="(tableValye, tableKey) in pageShowData.jurFormVoList[0].jurconfigform" :key="tableKey" show-overflow-tooltip
                                         :min-width="tableValye.fieldWeight" :prop="tableValye.entityField" :label="tableValye.showField">
                            <template slot-scope="scope">
                                <span v-if="tableValye.fieldType == 'date'">
                                    <span v-if="scope.row[tableValye.entityField]">
                                        {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                                    </span>
                                </span>
                                <el-tag size="mini" v-else-if="tableValye.entityField == 'isWms'">
                                    {{ scope.row.isWms == 0 ? '否' : '是' }}
                                </el-tag>
                                <span v-else-if="tableValye.isRift == 1">
                                    <a @click="toDetail(scope.row[tableValye.riftField])">{{
                            scope.row[tableValye.entityField] }}</a>
                                </span>
                                <el-tag v-else-if="tableValye.fieldType == 'formatter'" size="mini">
                                    {{ $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField])
                        }}</el-tag>
                                <span v-else>
                                    {{ scope.row[tableValye.entityField] }}
                                </span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
        </el-tabs>

        <div class="page_content_bottom">
            <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
        </div>

        <!-- 自定义设计 -->
        <customDesign ref="customDesign"></customDesign>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" width="800px">
            <SearchScheme ref="searchScheme" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" />
        </el-dialog>
        <printPlan ref="printPlan"></printPlan>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
export default {
    data() {
        //这里存放数据
        return {
            requesUrl: "",
            activeName: 'first',
            tableHeight: 0,
            getRequestData: {},
            returnData: {
                total: 0, // 总条数
                list: [],
                detailsList: [],
            },
            selectedDataIndex: 0,
            buttonList: [],
            pageShowData: [],
            formDataList: [],
            showStatus: false,
            actionData: {},
            seId: "",
            dialogTitle: "",
            seWidth: "",
            seTitle: "",
            DialogVisible: false,
            smId: "",
            sField: "",
            parentSearchData: {},

        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        handleClick() {
            this.getRequestData.page=1
            this.getDataList()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val
        },
        sortChange(column) {
            this.returnData.list = this.$common.sortChange(column, this.returnData.list, this.pageShowData.jurTableVo.jurconfigtable, 'entityField')
        },
        rowClick(row) {
            this.selectedDataIndex = row.index
        },
        rowClassName({ row }) {
            let rowName = ""
            if (row.index == this.selectedDataIndex) {
                rowName = "rowStyle"
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        // 检索Id, 索引(表格中), 标识
        openSearch(sId, index, type, sField) {
            if (type == 'salesName') {
                if (this.getRequestData.smId == undefined || this.getRequestData.smId == '') {
                    return this.$message({
                        message: "请先选择单位",
                        type: "error",
                    });
                } else {
                    this.parentSearchData.smId = this.getRequestData.smId
                }
            }
            this.sField = sField;
            this.DialogVisible = true;
            this.seId = sId;
            this.parentSearchData[type] = this.getRequestData[type];
        },
        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(',')
            arr.forEach(item => {
                this.getRequestData[item] = val[item]
            })
        },
        // 初始化赋值字段值
        initParamValue(setField) {
            let arr = setField.split(',')
            arr.forEach(item => {
                this.$set(this.getRequestData, item, "")
            })
        },
        // 清空赋值字段
        claerValue(field, pField) {
            if (this.getRequestData[field] == '') {
                this.initParamValue(pField)
            }
        },
        // 检索方案带回数据
        changeInputModel(val) {
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                this.paramValue(val)
            }
        },

        // 子组件触发
        drawerCancel(e) {
            this.showStatus = false
            if (e == 1) this.getDataList()
        },
        // 点击穿透字段 传参单号
        toDetail(orderId) {
            if (orderId) {
                // 设置为true 打开穿透组件首页    
                var isPenetrate = true
                // 设置缓存 存入点击单号
                this.resetSetItem('penetrateOrderId', orderId);
                // 与父级跨域通信 传递isPenetrate参数
                window.parent.postMessage({ //向窗口发送MessageEvent消息
                    cmd: 'returnFormJson',
                    params: {
                        isPenetrate
                    } //参数
                }, '*');
            }
            this.getPageInfo()
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        
        isShowData(name, value) {
            switch (name) {
                case "ovmApper":
                    var dataInfo = JSON.parse(sessionStorage.getItem("selectUserData"));
                    this.getRequestData.ovmApper = dataInfo.opmId;
                    this.getRequestData.opmName = dataInfo.opmName;
                default:
                    this.getRequestData[name] = value;
            }
        },

        // 获取数据列表
        async getPageInfo() {
            var pathId = parent.getMenuInfo(this.$route.path);
            let responseData = await this.$http.getJur({
                ids: [pathId.jurId]
            });
            if (responseData.status == 200) {
                this.pageShowData = responseData.result;
                var obj = {}
                if (this.pageShowData.jurHead) {
                    obj = this.$common.getSearchData(this.pageShowData.jurHead.jurconfigform, 'page', "rows", 30)
                } else {
                    obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
                }
                for (const key in obj) {
                    this.$set(this.getRequestData, key, obj[key])
                }
                this.getButtonList();
                this.getDataList();
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        clear(val) {
            if (val) {
                var arr = val.split(",")
                arr.forEach(item => {
                    this.$set(this.getRequestData, item, "")
                })
            }
        },
        // 动作集合
        actionSet(actionData) {
            console.log(actionData.actionType, 'actionData.actionType');

            switch (actionData.actionType) {
                case 10:
                    this.showPrintPlan()
                    break;
                case 11:
                    if (this.returnData.list.length == 0) {
                        this.$message.warning("暂无数据可以导出！")
                        return
                    }
                    this.getRequestData.ormId = sessionStorage.getItem("ormId");
                    if (this.activeName=='first') {
                        window.location.href = this.requesUrl + `/retailWeb/exportWebOrder${this.$common.getUrl(
                            this.getRequestData
                        )}`;
                    }else if (this.activeName=='second') {
                        window.location.href = this.requesUrl + `/retailWeb/exportWebOrderDetail${this.$common.getUrl(
                            this.getRequestData
                        )}`;
                    }
                    break;
            }
        },
        showPrintPlan() {
            // 检查是否有选中的数据
            if (this.multipleSelection.length <= 0) {
                this.$message({
                    message: "请先选择您要操作的数据",
                    type: "error",
                });
                return false;
            }
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(this.multipleSelection.map(item => item.retailId), sessionStorage.getItem('printSource').replace(/\"/g, ""), sessionStorage.getItem('printJurId'), '', 'all')
            } else {
                return
            }
        },
        openFormDesign() {
            let pathInfo = parent.getMenuInfo(this.$route.path)
            this.$refs['customDesign'].openBox(pathInfo.jurId, this.pageShowData, pathInfo.jurName)
        },
        // 数据搜索
        searchData() {
            this.getRequestData.page = 1;
            this.getDataList();
        },
        // 数据翻页
        setDataPageNumber(val) {
            this.getRequestData.page = val;
            this.getDataList();
        },

        // 切换显示条数
        setDataPageSize(val) {
            this.getRequestData.page = 1;
            this.getRequestData.rows = val;
            this.getDataList();
        },

        // 获取数据列表
        async getDataList() {
            let responseData;
            if (this.activeName == 'first') {
                responseData = await this.$http.retailWebqueryWebOrder(this.getRequestData);
            } else if (this.activeName == 'second') {
                responseData = await this.$http.retailWebqueryWebOrderDetail(this.getRequestData)
            }
            if (responseData.status == 200) {
                this.returnData.list = this.$common.getIndex(responseData.result.list)
                this.returnData.total = responseData.result.total;
                this.selectedDataIndex = 0
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取按钮权限
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton()
            
        },
},
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.requesUrl = window.global_config.BASE_URL;

        this.getPageInfo();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { this.tableHeight = this.$common.getTableHeight() }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

.el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
}

.el-table .rowStyle {
    background: #fff7ca !important;
}

.input {
    width: 200px !important;
}

::v-deep .el-divider--horizontal {
    margin: 15px 0;
}
</style>